export const PRODUCTION = (process.env.NODE_ENV === 'production');



// WEBPACK FOOTER //
// ./app/javascript/utils/env.js